import { render, staticRenderFns } from "./SingleClassroomHeader.vue?vue&type=template&id=59dc9c05&scoped=true&"
import script from "./SingleClassroomHeader.vue?vue&type=script&lang=js&"
export * from "./SingleClassroomHeader.vue?vue&type=script&lang=js&"
import style0 from "./SingleClassroomHeader.vue?vue&type=style&index=0&id=59dc9c05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dc9c05",
  null
  
)

export default component.exports